import React, { useMemo } from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import { FilterOperation } from '../../graphql/schema/p4types';
import ModalContext from '../../components/Context/ModalContext';
import MaxoptraNotificationResultsWorkspace from './MaxoptraNotificationResultsWorkspace';
import FluentModal from '../../components/modals/FluentModal';

const MaxoptraNotificationResultsModal = ({
  isOpen,
  batchId,
  onClose,
}: {
  isOpen: boolean;
  batchId: number;
  onClose: () => void;
}) => {
  const value = useMemo(
    () => ({
      onClose,
    }),
    [onClose]
  );

  return (
    <FluentModal isOpen={isOpen}>
      <ModalContext.Provider value={value}>
        {!batchId ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '500px' }}>
            <Spinner size={SpinnerSize.large} label="Loading notification results..." />
          </div>
        ) : (
          <MaxoptraNotificationResultsWorkspace
            title="Notification Results"
            embeddedView={true}
            predefinedFilters={[
              {
                filterOperation: FilterOperation.Equals,
                filterParameters: {
                  field: 'notificationBatch.id',
                  value: batchId,
                },
              },
              {
                filterOperation: FilterOperation.NotEquals,
                filterParameters: {
                  field: 'failureMessage',
                  value: '',
                },
              },
            ]}
            viewScreenName="/MaxoptraNotification/Modal"
            removeAddButton={true}
            contentHeight={500}
            onBack={onClose}
            includeHeader={true}
            enableRowSelect={false}
            disableViewToolbar={true}
            disableViewController={true}
            noReport={true}
          />
        )}
      </ModalContext.Provider>
    </FluentModal>
  );
};

export default MaxoptraNotificationResultsModal;
